import { render, staticRenderFns } from "./SelectedChildren.vue?vue&type=template&id=162e910b&scoped=true&"
import script from "./SelectedChildren.vue?vue&type=script&lang=js&"
export * from "./SelectedChildren.vue?vue&type=script&lang=js&"
import style0 from "./SelectedChildren.vue?vue&type=style&index=0&id=162e910b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162e910b",
  null
  
)

export default component.exports